import { useCallback } from 'react';

import { useOnWorkflowTrackerComplete } from '@/modules/workflowTrackers/hooks/useOnWorkflowTrackerComplete';
import {
  WorkflowTracker,
  WorkflowTrackerKind,
  WorkflowTrackerStatus,
} from '@/types/schema';

/**
 * Calls `onCompleted` when a memo generation that the current user started
 * for the household completes. A completed generation adds a memo or changes
 * one, so callers use this to load their memo list again.
 */
export function useOnMemoGenerationComplete(
  householdId: string,
  onCompleted: () => void
) {
  useOnWorkflowTrackerComplete({
    kind: WorkflowTrackerKind.MemoGeneration,
    filter: useCallback(
      (tracker: WorkflowTracker) =>
        tracker.status === WorkflowTrackerStatus.Started &&
        tracker.householdID === householdId,
      [householdId]
    ),
    onCompleted,
  });
}
